export const fullSizeNetworkWidgetAspectRatio = 526 / 192;
export const halfSizeNetworkWidgetAspectRatio = 368 / 192;
